const schema = {
  name: 'sparkpocketjoy',
  version: 1,
  create_database: ({ indexed_db }) => {
    indexed_db.createObjectStore( 'content-data' )
  },
}

export default schema
